import FeatureGates, {
    FeatureGateEnvironment,
    FromValuesClientOptions
} from "@atlassian/feature-gate-js-client";
import { CustomAttributes } from "@atlassian/feature-gate-node-client-bootstrapper";

import { FeatureGatesBootstrapValues } from "./types";

export const TARGET_APP = "bxp-web-platform_web";

const getEnvironment = (): FeatureGateEnvironment => {
    switch (process.env["CLIENT_LIBRARY_ENV"]) {
        case "production":
            return FeatureGateEnvironment.Production;
        case "staging":
            return FeatureGateEnvironment.Staging;
        case "development":
        default:
            return FeatureGateEnvironment.Development;
    }
};

export const initializeFeatureGatesClient = async (
    bootstrapValues: FeatureGatesBootstrapValues,
    options: Omit<
        FromValuesClientOptions,
        "environment" | "targetApp" | "sdkKey"
    > = {}
) => {
    await FeatureGates.initializeFromValues(
        {
            ...options,
            environment: getEnvironment(),
            targetApp: TARGET_APP,
            sdkKey: bootstrapValues.clientSdkKey,
            eventLoggingApi: "https://xp.atlassian.com/v1/"
        },
        bootstrapValues.identifiers,
        bootstrapValues.customAttributes as CustomAttributes,
        bootstrapValues.experimentValues
    );
};
